import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
    FormStage,
    FormState,
    FormData,
    LoanCalculate,
    StaticFetchData,
    FormStep,
} from "@/lib/types/shinhan/form";
import { Transform } from "@/lib/helper";
import { LoanService } from "@/services";

const formStage: FormStage = {
    introStage: true,
    currentStage: 0,
    isAcceptConsent: true,
    stage1: "",
    stage2: "",
    stage5: "",
};

const formStep: FormStep = {
    currentStep: 0,
    steps: [
        {
            title: 'Thông tin số tiền cần hỗ trợ',
            time: '2 phút',
            fields: ['month', 'coupon', 'schoolType', 'school', 'semester', 'admissionMethod', 'referral']
        },
        {
            title: 'Thông tin cá nhân và liên hệ',
            time: '2 phút',
            fields: ['name', 'student_id', 'email', 'phoneNumber', 'studentAccount', 'studentPassword', 'cosignerName', 'cosignerRelationship', 'cosignerPhoneNumber', 'isBadDebt', 'cccd']
        },
        {
            title: 'Xác nhận và gửi',
            time: '1 phút',
            fields: []
        },
    ]
}

const formData: FormData = {
    //Stage One
    amount: 1000000,
    month: 4,
    coupon: '',
    schoolType: "",
    school: "",
    semester: "",
    admissionMethod: "",
    referral: '',

    //Stage Two
    name: "",
    student_id: "",
    email: "",
    phoneNumber: "",
    studentAccount: "",
    studentPassword: "",
    cosignerName: "",
    cosignerRelationship: "",
    cosignerPhoneNumber: "",
    //otp status
    isOtpVerified: false,
    //cccd
    cccd: "",
    //is bad debt
    isBadDebt: ''
};

const loanCalculate: LoanCalculate = {
    totalPayPerMonth: 0,
    total: 0,
    baseTotal: 0,
    serviceFee: 0,
    interestTotal: 0,
    payStartDate: '',
    interestTotalWithoutDiscount: 0,
    discountAmount: 0,
};

const staticData: StaticFetchData = {
    isFetched: false,
    schools: [],
    rates: {},
    questions: [],
};

const initialState: FormState = {
    formStage: formStage,
    formStep: formStep,
    formData: formData,
    loanCalculate: loanCalculate,
    loanScheduleCalculate: [],
    staticFetchData: staticData,
};

export const shinhanFormSlice = createSlice({
    name: "shinhan-form",
    initialState,
    reducers: {
        initializeData: (state, actions: PayloadAction<any>) => {
            //init data
            state.staticFetchData.rates = actions.payload.rates
            state.staticFetchData.schools = actions.payload.schools
            state.staticFetchData.questions = actions.payload.questions

            //mark fetched
            state.staticFetchData.isFetched = true
        },
        updateFormData: (state, actions: PayloadAction<any>) => {
            const transform = new Transform();
            let formData = actions.payload
            formData.amount = transform.transformMoneyToNumber(formData.amount)
            state.formData = { ...current(state.formData), ...formData }
        },
        changeStep: (state, actions: PayloadAction<number>) => {
            state.formStep.currentStep = actions.payload
        },
        calculateLoanAmount: (
            state,
            actions: PayloadAction<{ amount: any, month: any, discount?: any }>
        ) => {
            const loanService = new LoanService();
            const transform = new Transform();
            let amount = transform.transformMoneyToNumber(
                actions.payload.amount || "0"
            );

            const data = loanService.loanAmountIinfo(
                amount,
                actions.payload.month || 4,
                current(state.staticFetchData.rates),
                actions.payload.discount
            );

            const scheduleData = loanService.calculateSchedulePerMonth(
                amount,
                actions.payload.month || 4,
                current(state.staticFetchData.rates),
                actions.payload.discount
            );
            state.loanCalculate = data;
            state.loanScheduleCalculate = scheduleData;
        }
    },
});

export const { initializeData, calculateLoanAmount, changeStep, updateFormData } =
    shinhanFormSlice.actions;
export default shinhanFormSlice;
